module.exports = __webpack_public_path__ + "img/wings.7ecfa7d6.jpg";